<template>
  <div class="rounded-md">
    <div class="px-16 py-12 border-border border hover:border-primary-background cursor-pointer rounded-md flex justify-between" @click="modalOpen = true">
      <div
        class="absolute transition-all"
        :class="{
          'text-dark base': !selectedString,
          'translate-y-[-22px] translate-x-[-12px] bg-white base text-darker scale-75 px-4': !!selectedString
        }"
      >
        {{ selectLabel }}
      </div>
      <div>
        <div
          v-if="selectedString"
          class="base text-darker"
        >
          {{ selectedString }}
        </div>
      </div>
      <div class="flex items-center">
        <div v-if="isOptional" class="text-tiny uppercase text-dark mt-2">Valfritt</div>
        <ion-icon
          aria-hidden="true"
          :icon="chevronDown"
          class="text-primary-default w-14 h-14 ml-12"
        />
      </div>
    </div>

    <Modal
      :open="modalOpen"
      :label="selectLabel"
      :initial-breakpoint="1"
      :breakpoints="[0, 1]"
      @close="modalOpen = false"
    >
      <div>
        <div class="pt-16 px-16 pb-48">
          <div
            v-for="option in options"
            :key="option.value"
            :value="option.value"
            class="w-full flex justify-between items-center py-8 border-b border-border"
          >
            <label class="flex w-full items-center">
              <div class="basis-[30px]">
                <input
                  v-if="multiselect"
                  class="checkbox"
                  type="checkbox"
                  :checked="selectedListValue && selectedListValue.includes(option.value)"
                  @click="checkOption(option.value)"
                >
                <input
                  v-else
                  class="radio"
                  type="radio"
                  name="radioOptions"
                  :checked="selectedValue === option.value"
                  @click="checkOption(option.value)"
                >
              </div>
              <div class="flex justify-between items-center flex-1">
                <div>
                  <div>
                    {{ option.label }}
                  </div>
                </div>
              </div>
            </label>
          </div>
          <div class="pt-32">
            <Button
              class="mb-12"
              :text="'Bekräfta'"
              :type="'primary'"
              @click="submitChange"
            />
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script lang="ts" setup>
import { IonIcon } from '@ionic/vue';
import Modal from '@/components/Modal.vue';
import { computed, ref, watch } from 'vue';
import Button from '@/components/Button.vue';
import { chevronDown } from 'ionicons/icons';

const props = defineProps<{
  options: {
    value: string | number;
    label: string;
  }[];
  selectLabel: string;
  isOptional?: boolean;
  defaultValue?: string | number | Array<string | number>;
  multiselect?: boolean;
  outsideTriggerOpen?: boolean;
}>();

const selectedValue = ref(props.defaultValue ? props.defaultValue : null);
const modalOpen = ref(false);

const emit = defineEmits<{
  (e: 'change', payload: string | number | boolean | Array<string | number>): void;
  (e: 'close'): void;
}>();

const checkOption = (input: string | number) => {
  if (props.multiselect) {
    let selected = (selectedValue.value || []) as Array<string | number>;
    if (selected.includes(input)) {
      selected = selected.filter(value => input !== value);
    } else {
      selected = [...selected, input];
    }
    selectedValue.value = selected;
  } else {
    selectedValue.value = selectedValue.value === input ? null : input;
  }
  emit('change', selectedValue.value);
};

const selectedListValue = computed(() => {
  if (props.multiselect) {
    return selectedValue.value as Array<string | number>;
  } else {
    return null;
  }
});

const submitChange = () => {
  emit('change', selectedValue.value);
  modalOpen.value = false;
};

const selectedString = computed(() => {
  if (props.multiselect) {
    const selected = selectedValue.value as Array<string | number>;
    return selected?.length ? `${selected?.length} val gjorda` : null;
  } else {
    return props.options.find(option => option.value === selectedValue.value)?.label || null;
  }
});

watch(
  () => props.outsideTriggerOpen,
  (open) => {
    modalOpen.value = open;
  }
);
</script>
